module.exports = __webpack_public_path__ + "img/3ce9c5991d6ac9fc7dbb5f1dcc597c95.png";